import React from 'react';
import { Route, Routes as RouterRoutes } from 'react-router-dom';

// Import your route components
const Home = React.lazy(() => import('../../containers/Home'));
const Login = React.lazy(() => import('../../containers/Login'));
const LoginClient = React.lazy(() => import('../../containers/LoginClient'));
const BrokerCompanySignUp = React.lazy(() => import('../../containers/BrokerCompanySignup'));
const ClientPrivacy = React.lazy(() => import('../../containers/ClientPrivacy'));
const ClientTerms = React.lazy(() => import('../../containers/ClientTerms'));
const Dashboard = React.lazy(() => import('../../containers/Dashboard'));
const Summary = React.lazy(() => import('../../containers/Summary'));
const Workflow = React.lazy(() => import('../../components/Workflow'));
const Quote = React.lazy(() => import('../../containers/Quote'));
const IndicativeQuote = React.lazy(() => import('../../containers/IndicativeQuote'));
const HomeValuation2 = React.lazy(() => import('../../containers/HomeValuation2'));
const HomeValuation = React.lazy(() => import('../../containers/HomeValuation'));
const HomeValuationLogin = React.lazy(() => import('../../containers/HomeValuationLogin'));
const HomeValuationError = React.lazy(() => import('../../containers/HomeValuationError'));
const HomeValuationAddress = React.lazy(() => import('../../containers/HomeValuationAddress'));
const HomeValuationAddress2 = React.lazy(() => import('../../containers/HomeValuationAddress2'));
const ThankYou = React.lazy(() => import('../../containers/ThankYou'));
const Payment = React.lazy(() => import('../../containers/Payment'));
const CreditSetup = React.lazy(() => import('../../containers/CreditSetup'));
const DebitSetup = React.lazy(() => import('../../containers/DebitSetup'));
const PaymentNotRequired = React.lazy(() => import('../../containers/PaymentNotRequired'));
const PaymentError = React.lazy(() => import('../../containers/PaymentError'));
const FinancingPrivacyPolicy = React.lazy(() => import('../../containers/FinancingPrivacyPolicy'));
const PrivacyPolicy = React.lazy(() => import('../../containers/PrivacyPolicy'));
const TermsOfService = React.lazy(() => import('../../containers/TermsOfService'));
const Redirect = React.lazy(() => import('../../containers/Redirect'));
const FourOhFour = React.lazy(() => import('../../containers/FourOhFour'));
const ErrorPage = React.lazy(() => import('../../containers/Error'));
const Product = React.lazy(() => import('../../containers/Product'));
const Embedded = React.lazy(() => import('../../containers/Embedded'));
const Checkout = React.lazy(() => import('../../containers/Checkout'));
const PaymentCheckout = React.lazy(() => import('../../containers/PaymentCheckout'));
const PaymentCheckoutReturn = React.lazy(() => import('../../containers/PaymentCheckoutReturn'));
const Confirmation = React.lazy(() => import('../../containers/Confirmation'));
const Unsubscribe = React.lazy(() => import('../../containers/Unsubscribe'));
const IndicativeQuoteSummary = React.lazy(() => import('../../containers/IndicativeQuoteSummary'));
const Appraisal = React.lazy(() => import('../../containers/Appraisal'));
const BrokerCompanySignUpCheckout = React.lazy(() => import('../../containers/BrokerCompanySignup/Checkout'));
const BrokerCompanySignUpCheckoutReturn = React.lazy(
    () => import('../../containers/BrokerCompanySignup/CheckoutReturn'),
);
const SmoMembershipJoin = React.lazy(() => import('../../containers/SmoMembershipJoin'));
const SmoMembershipSignUp = React.lazy(() => import('../../containers/SmoMembershipSignUp'));

// -- Dynamic Imports Starts --

// -- Dynamic Imports Ends --

export const AppRoutes = (props) => {
    const withProps = (Component) => (routeProps) => <Component {...routeProps} {...props} />;

    const withExtraProps = (Component, extraProps) => (routeProps) => (
        <Component {...routeProps} {...props} {...extraProps} />
    );

    return (
        <React.Suspense fallback={<div />}>
            <RouterRoutes>
                {/* -- Dynamic Routes Start -- */}

                {/* -- Dynamic Routes End -- */}

                <Route path='/' element={withProps(Home)()} />
                <Route path='/login' element={withProps(Login)()} />
                <Route path='/client/login' element={withProps(LoginClient)()} />
                <Route path='/broker-company-signup' element={withProps(BrokerCompanySignUp)()} />
                <Route path='/client-privacy' element={withProps(ClientPrivacy)()} />
                <Route path='/client-terms' element={withProps(ClientTerms)()} />

                <Route path='/dashboard/*' element={withProps(Dashboard)()} />
                <Route path='/profile' element={withProps(Summary)()} />
                <Route path='/workflow' element={withProps(Workflow)()} />
                <Route path='/quote' element={withProps(Quote)()} />
                <Route path='/indicativeQuote' element={withProps(IndicativeQuote)()} />
                <Route path='/homevaluation2/client' element={withProps(HomeValuation2)()} />
                <Route path='/homevaluation/client' element={withProps(HomeValuation)()} />
                <Route path='/homevaluation' element={withProps(HomeValuation)()} />
                <Route
                    path='/homevaluation-preview/:previewBrokerageGuid'
                    element={withExtraProps(HomeValuation, { isPreviewMode: true })()}
                />
                <Route
                    path='/homevaluation-preview-nonsubscriber/:brokerageRoleCode/:provinceCode/:previewBrokerageGuid'
                    element={withExtraProps(HomeValuation, { isPreviewMode: true, isNonSubscriber: true })()}
                />
                <Route path='/homevaluation/login' element={withProps(HomeValuationLogin)()} />
                <Route path='/homevaluation/error' element={withProps(HomeValuationError)()} />
                <Route path='/homevaluation/address' element={withProps(HomeValuationAddress)()} />
                <Route path='/homevaluation2/address' element={withProps(HomeValuationAddress2)()} />

                <Route path='/checkout' element={withProps(Checkout)()} />
                <Route path='/payment-checkout' element={withProps(PaymentCheckout)()} />
                <Route path='/payment-checkout-return' element={withProps(PaymentCheckoutReturn)()} />
                <Route path='/confirmation' element={withProps(Confirmation)()} />
                <Route path='/account/unsubscribe' element={withProps(Unsubscribe)()} />
                <Route path='/indicativeQuoteSummary' element={withProps(IndicativeQuoteSummary)()} />
                <Route path='/appraisal' element={withProps(Appraisal)()} />
                <Route path='/broker-company-signup/checkout' element={withProps(BrokerCompanySignUpCheckout)()} />
                <Route
                    path='/broker-company-signup/checkout/return'
                    element={withProps(BrokerCompanySignUpCheckoutReturn)()}
                />

                <Route path='/smo-membership' element={withProps(SmoMembershipJoin)()} />
                <Route path='/smo-broker-company-signup' element={withProps(SmoMembershipSignUp)()} />

                <Route path='/send-quote' element={<div>send-quote page</div>} />
                <Route path='/my-quotes' element={<div>my-quotes page</div>} />
                <Route path='/my-info' element={<div>my-info page</div>} />
                <Route path='/my-claims' element={<div>my-claims page</div>} />
                <Route path='/contact-my-broker' element={<div>contact-my-broker page</div>} />
                <Route path='/thankyou' element={withProps(ThankYou)()} />

                <Route path='/payment/*' element={withProps(Payment)()} />
                <Route path='/credit-setup/*' element={withProps(CreditSetup)()} />
                <Route path='/debit-setup/*' element={withProps(DebitSetup)()} />
                <Route path='/payment-not-required/*' element={withProps(PaymentNotRequired)()} />
                <Route path='/payment-error/*' element={withProps(PaymentError)()} />
                <Route path='/financing-privacy-policy' element={withProps(FinancingPrivacyPolicy)()} />

                <Route path='/privacy' element={withProps(PrivacyPolicy)()} />
                <Route path='/terms' element={withProps(TermsOfService)()} />
                <Route path='/redirect' element={withProps(Redirect)()} />
                <Route path='/404' element={withProps(FourOhFour)({ type: 'api_fail' })} />
                <Route path='/error' element={withProps(ErrorPage)()} />

                <Route path='/@:agentName' element={withProps(Home)()} />
                <Route path='/product/:productName/@:agentName' element={withProps(Product)()} />
                <Route path='/product/:productName' element={withProps(Product)()} />
                <Route path='/embedded' element={withProps(Embedded)()} />
                <Route path='*' element={withProps(FourOhFour)()} />
            </RouterRoutes>
        </React.Suspense>
    );
};
